import httpService from "../../services/httpService";
import { ApiEndpoints } from "../../constants/apiEndpoints";
import { AdminDashboardData } from "../../types/admin";

function n(value: unknown): number {
  return typeof value === "number" && Number.isFinite(value) ? value : 0;
}

function mapDashboardData(payload: any): AdminDashboardData {
  return {
    users: {
      total: n(payload?.users?.total),
      active: n(payload?.users?.active),
      new_last_7_days: n(payload?.users?.new_last_7_days),
      new_last_30_days: n(payload?.users?.new_last_30_days),
    },
    songs: {
      total: n(payload?.songs?.total),
      published: n(payload?.songs?.published),
      draft: n(payload?.songs?.draft),
      archived: n(payload?.songs?.archived),
    },
    song_requests: {
      total: n(payload?.song_requests?.total),
      pending: n(payload?.song_requests?.pending),
      in_progress: n(payload?.song_requests?.in_progress),
      completed: n(payload?.song_requests?.completed),
      rejected: n(payload?.song_requests?.rejected),
    },
    notifications: {
      total_sent: n(payload?.notifications?.total_sent),
      sent_last_7_days: n(payload?.notifications?.sent_last_7_days),
      failed: n(payload?.notifications?.failed),
    },
    devices: {
      registered: n(payload?.devices?.registered),
      notification_enabled: n(payload?.devices?.notification_enabled),
    },
  };
}

export const fetchDashboard = async (): Promise<AdminDashboardData> => {
  const response = await httpService.get<any>(ApiEndpoints.ADMIN_DASHBOARD);
  return mapDashboardData(response.data);
};
